function MonthlyReport() {
  return <div>Banners</div>;
}

export default MonthlyReport;
